var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2662",
    "data-name": "Group 2662",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.292,
    height: 18.674,
    viewBox: "0 0 23.292 18.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_950",
    "data-name": "Rectangle 950",
    width: 23.292,
    height: 18.674,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2601",
    "data-name": "Group 2601",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M0,9.011a2.454,2.454,0,0,1,.726-.887Q4.7,4.649,8.675,1.17c.33-.289.66-.579.993-.865a1.19,1.19,0,1,1,1.568,1.789Q8.345,4.634,5.445,7.166c-.352.308-.7.618-1.1.968H21.993a1.2,1.2,0,1,1,.168,2.387c-.1.005-.2,0-.3,0H4.345c.387.342.73.646,1.076.948q2.821,2.467,5.643,4.933a1.34,1.34,0,0,1,.588,1.048,1.137,1.137,0,0,1-.695,1.1,1.124,1.124,0,0,1-1.272-.189c-.843-.726-1.678-1.463-2.515-2.2L1.119,10.877c-.234-.2-.469-.407-.7-.615A1.856,1.856,0,0,1,0,9.647Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.ad8fce86357fea75ada665d2fff8347e.svg";
export { ForwardRef as ReactComponent };